export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

type AsyncChunkCallback<T> = (item: T) => Promise<void>;

// Renamed chunkArray to chunkProcess; processes items in chunks with an async callback
export async function chunkProcess<T>(array: T[], chunkSize: number, callback: AsyncChunkCallback<T>, signal?: AbortSignal): Promise<void> {
  for (let i = 0; i < array.length; i += chunkSize) {
    if (signal?.aborted) {
      throw new Error("Chunk processing aborted");
    }
    const chunk = array.slice(i, i + chunkSize);
    // Process each chunk in parallel using Promise.all
    await Promise.all(chunk.map(callback));
  }
}

export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function gridToBuffer(arrays: number[][]): ArrayBuffer {
  // Calculate total size: 4 bytes for array count, 4 bytes per sub-array length, 8 bytes per number (Float64)
  const arrayCount = arrays.length;
  let totalNumbers = 0;
  for (const arr of arrays) {
    totalNumbers += arr.length;
  }
  const buffer = new ArrayBuffer(4 + 4 * arrayCount + 8 * totalNumbers);
  const view = new DataView(buffer);

  // Write array count
  view.setUint32(0, arrayCount, true); // Little-endian

  // Write sub-array lengths
  let offset = 4;
  for (const arr of arrays) {
    view.setUint32(offset, arr.length, true);
    offset += 4;
  }

  // Write numbers
  for (const arr of arrays) {
    for (const num of arr) {
      view.setFloat32(offset, num, true);
      offset += 8;
    }
  }

  return buffer;
}

export function bufferToGrid(buffer: ArrayBuffer): number[][] {
  const view = new DataView(buffer);
  const arrayCount = view.getUint32(0, true);
  const result: number[][] = [];

  // Read sub-array lengths
  const lengths: number[] = [];
  let offset = 4;
  for (let i = 0; i < arrayCount; i++) {
    lengths.push(view.getUint32(offset, true));
    offset += 4;
  }

  // Read numbers
  for (const length of lengths) {
    const subArray: number[] = [];
    for (let i = 0; i < length; i++) {
      subArray.push(view.getFloat32(offset, true));
      offset += 8;
    }
    result.push(subArray);
  }

  return result;
}